import { render } from "./FriendlyRobotProject.vue?vue&type=template&id=7121a81d&scoped=true"
const script = {}

import "./FriendlyRobotProject.vue?vue&type=style&index=0&id=7121a81d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7121a81d"]])

export default __exports__